import ProductPage from "../../components/ProductPage";
import { dematAccountData } from "../../data/productsData";
export default function DematAccount() { return <ProductPage data={dematAccountData} />; }